import React, { useEffect, useState, useContext, useRef } from "react";
import Swal from "sweetalert2";
import Footer from "../Templete/Footer";
import Header from "../Templete/Header";

import FormService from "../../Services/FormService";
import LoadingContext from "../../Store/loading-context";
import HttpError from "../../utill/HttpError";

const ContactUs = () => {
  useEffect(() => {
    document.title = "Contact Us - NexPe";
  }, []);

  const loadingCtx = useContext(LoadingContext);

  const [message, setMessage] = useState();

  const formRef = useRef();
  const fnameRef = useRef();
  const lnameRef = useRef();
  const emailRef = useRef();
  const mobileRef = useRef();
  const subjectRef = useRef();

  const submitHandler = async () => {
    const fname = fnameRef.current.value;
    const lname = lnameRef.current.value;
    const email = emailRef.current.value;
    const mobile = mobileRef.current.value;
    const subject = subjectRef.current.value;

    if (fname == "") {
      Swal.fire("Opps!", "Please Enter First Name", "error");
      return;
    }

    if (lname == "") {
      Swal.fire("Opps!", "Please Enter Last Name", "error");
      return;
    }

    if (email == "") {
      Swal.fire("Opps!", "Please Enter Email ID", "error");
      return;
    }

    if (mobile == "") {
      Swal.fire("Opps!", "Please Enter Mobile Number", "error");
      return;
    }

    if (subject == "") {
      Swal.fire("Opps!", "Please Enter Subject", "error");
      return;
    }

    if (message == "") {
      Swal.fire("Opps!", "Please Enter Message", "error");
      return;
    }

    loadingCtx.startLoading();

    try {
      const responseData = await FormService.contactForm(
        fname + " " + lname,
        email,
        mobile,
        subject,
        message,
      );

      const status = responseData.status;
      const message2 = responseData.message;

      if (status === "SUCCESS") {
        formRef.current.reset();
        Swal.fire("Success!", message2, "success");
      } else {
        Swal.fire("Opps!", message2, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }

    loadingCtx.stopLoading();
  };

  return (
    <React.Fragment>
      <div class="page_wrapper">
        <Header headerType="white_header" />

        <main>
          {/* breadcrumb area start */}
          <section className="nh_breadcrumb-area">
            <div
              className="nh_breadcrumb-wrap"
              data-background="assets/images/bg/breadcrumb.webp"
            >
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-xl-7">
                    <div className="nh_breadcrumb-content text-center">
                      <h2 className="nh_breadcrumb-content-title">
                        Contact Us
                      </h2>
                      <div className="nh_breadcrumb-content-list">
                        <a href="/">Home</a>
                        <span>Contact Us</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* breadcrumb area end */}
          {/* contact area start */}
          <section className="nh_inner_contact-area pt-100 pb-60">
            <div className="container">
              <div className="row justify-content-between">
                <div className="col-xl-5 col-lg-5">
                  <div className="nh_inner_contact-left pb-10">
                    <div className="nh_section-area mb-25 pb-2">
                      <span className="nh_section-subtitle nh_section-subtitle-inner">
                        Contact us
                      </span>
                      <h2 className="nh_section-title nh_section-title-small mb-15">
                        Have questions? Need assistance? Our team is here to
                        help!
                      </h2>
                      <p className="nh_section-text mb-0">
                        Reach out anytime for support or inquiries.
                      </p>
                    </div>
                    <div className="nh_inner_contact-content">
                      <div className="nh_inner_contact-item mb-30">
                        <div className="nh_inner_contact-item-icon">
                          <svg
                            width="19.472656"
                            height="24.591797"
                            viewBox="0 0 19.4727 24.5918"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                          >
                            <desc>Created with Pixso.</desc>
                            <defs />
                            <path
                              id="Vector"
                              d="M18.69 9.99C18.69 4.9 14.68 0.77 9.73 0.77C4.78 0.77 0.77 4.9 0.77 9.99C0.77 15.08 5.25 19.2 9.73 23.81C14.21 19.2 18.69 15.08 18.69 9.99Z"
                              stroke="currentColor"
                              strokeOpacity={1.0}
                              strokeWidth="1.551724"
                              strokeLinejoin="round"
                            />
                            <path
                              id="Vector"
                              d="M13.58 9.73C13.58 7.61 11.86 5.89 9.74 5.89C7.62 5.89 5.9 7.61 5.9 9.73C5.9 11.85 7.62 13.57 9.74 13.57C11.86 13.57 13.58 11.85 13.58 9.73Z"
                              stroke="currentColor"
                              strokeOpacity={1.0}
                              strokeWidth="1.551724"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="nh_inner_contact-item-info">
                          <span>Address</span>
                          <p>
                            FINGTEL COMMUNICATIONS, <br />
                            Government Primary School Belwa Piparpati VILL-BELWA
                            PIPARPANTI ,TOLA-BELWA PIPARPANTI PANCH-SINGASANI
                            Nearby Landmark: Government Primary School Belwa
                            Piparpati, BLOCK RAMGARHWA City/Town/Village:
                            Ramgarhwa District: Purbi Champaran State: Bihar PIN
                            Code: 845433
                          </p>
                        </div>
                      </div>
                      <div className="nh_inner_contact-item mb-30">
                        <div className="nh_inner_contact-item-icon">
                          <svg
                            width="20.484375"
                            height="20.482910"
                            viewBox="0 0 20.4844 20.4829"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                          >
                            <desc>Created with Pixso.</desc>
                            <defs />
                            <path
                              id="Vector"
                              d="M11.75 4.85C12.71 5.03 13.59 5.5 14.28 6.19C14.97 6.88 15.44 7.76 15.62 8.72M11.75 0.93C13.74 1.15 15.6 2.04 17.01 3.45C18.43 4.87 19.32 6.72 19.55 8.71M0.92 4.36C0.92 3.98 0.94 3.6 0.97 3.23C1 2.8 1.01 2.59 1.12 2.4C1.22 2.24 1.38 2.08 1.55 2C1.75 1.91 1.98 1.91 2.46 1.91L5.22 1.91C5.61 1.91 5.81 1.91 5.98 1.97C6.13 2.03 6.26 2.12 6.37 2.24C6.49 2.38 6.55 2.57 6.69 2.94L7.83 6.08C7.99 6.51 8.07 6.73 8.06 6.94C8.05 7.12 7.98 7.29 7.88 7.44C7.76 7.61 7.56 7.72 7.17 7.96L5.82 8.77C7 11.36 9.11 13.47 11.71 14.65L12.51 13.31C12.75 12.91 12.87 12.71 13.03 12.59C13.18 12.49 13.35 12.43 13.54 12.42C13.74 12.4 13.96 12.48 14.39 12.64L17.53 13.78C17.91 13.92 18.09 13.98 18.23 14.1C18.35 14.21 18.44 14.34 18.5 14.49C18.57 14.66 18.57 14.86 18.57 15.25L18.57 18.02C18.57 18.49 18.57 18.72 18.47 18.92C18.39 19.09 18.23 19.25 18.07 19.35C17.88 19.46 17.67 19.47 17.24 19.51C16.87 19.53 16.5 19.55 16.12 19.55C7.73 19.55 0.92 12.75 0.92 4.36Z"
                              stroke="currentColor"
                              strokeOpacity={1.0}
                              strokeWidth="1.862069"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="nh_inner_contact-item-info">
                          <span>Phone</span>
                          <a href="tel:919471829860">+91 9471-829-860</a>
                        </div>
                      </div>
                      <div className="nh_inner_contact-item mb-30">
                        <div className="nh_inner_contact-item-icon">
                          <svg
                            width="20.691406"
                            height="16.927734"
                            viewBox="0 0 20.6914 16.9277"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                          >
                            <desc>Created with Pixso.</desc>
                            <defs />
                            <path
                              id="Vector"
                              d="M19.75 0L0.94 0C0.69 0 0.45 0.09 0.27 0.27C0.09 0.45 0 0.69 0 0.94L0 15.98C0 16.23 0.09 16.47 0.27 16.65C0.45 16.82 0.69 16.92 0.94 16.92L19.75 16.92C20 16.92 20.23 16.82 20.41 16.65C20.58 16.47 20.69 16.23 20.69 15.98L20.69 0.94C20.69 0.69 20.58 0.45 20.41 0.27C20.23 0.09 20 0 19.75 0ZM18.8 15.04L1.88 15.04L1.88 6.09L9.99 9.33C10.21 9.42 10.46 9.42 10.69 9.33L18.8 6.09L18.8 15.04ZM18.8 4.06L10.34 7.45L1.88 4.06L1.88 1.88L18.8 1.88L18.8 4.06Z"
                              fill="currentColor"
                              fillOpacity={1.0}
                              fillRule="nonzero"
                            />
                          </svg>
                        </div>
                        <div className="nh_inner_contact-item-info">
                          <span>Email</span>
                          <a href="mailto:care@nexpe.co.in">care@nexpe.co.in</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-7">
                  <div className="nh_inner_contact-form mb-40">
                    <h2 className="nh_inner_contact-title mb-35">
                      Get in touch with us!
                    </h2>
                    <form action="#" method="POST">
                      <div className="row g-20">
                        <div className="col-sm-6">
                          <input type="text" placeholder="Name*" />
                        </div>
                        <div className="col-sm-6">
                          <input type="text" placeholder="Phone*" />
                        </div>
                        <div className="col-sm-12">
                          <input type="email" placeholder="Email*" />
                        </div>
                        <div className="col-12">
                          <textarea
                            name="message"
                            placeholder="Message*"
                            defaultValue={""}
                          />
                        </div>
                        <div className="col-12">
                          <button
                            type="button"
                            className="nh_inner_contact-form-btn nh_inner_contact_radius"
                          >
                            Submit Now
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* contact area end */}
        </main>

        <Footer />
      </div>
    </React.Fragment>
  );
};

export default ContactUs;
